export default {"src":"/_next/static/media/gray-furniture.c21a9c89.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};